import React, { useContext } from "react";
import { ClinicaContext } from "../../../../../../shared/context/clinica-context";
import "./SingleUpcomingAppointment.scss";

function SingleUpcomingAppointment({ agendamento, mostrarTodos }) {
  /* ─── ONDE É A CONSULTA ─────────────────────────────────────────────────
   *
   * Só nas clínicas com mais do que uma unidade. Numa clínica de unidade
   * única seria uma coluna a repetir a mesma coisa em todas as linhas.
   *
   * A verificação é a mesma que o `BadgeUnidade` faz, mas aqui mostra-se o
   * NOME e não a sigla: a pastilha serve para quem trabalha lá e já sabe o
   * que «PRA» quer dizer; esta coluna existe para se dizer ao doente para
   * onde deve ir. */
  const clinica = useContext(ClinicaContext);
  const mostrarUnidade =
    clinica?.clinica?.multiEstabelecimento && agendamento.estabelecimento?.nome;

  return (
    <div className="single-agendamento caixa">
      <div className="single-agendamento--data single-agendamento--column single-agendamento--column--1">
        <div>
          <span className="single-agendamento--data--data">
            {agendamento.data}
          </span>
        </div>
        <div className="single-agendamento--data--horas">
          <span className="single-agendamento--data--hora">
            {agendamento.horaInicio} -
          </span>

          <span className="single-agendamento--data--hora">
            {` ${agendamento.horaFim}`}
          </span>
        </div>
      </div>

      <div className="single-agendamento--tratamento single-agendamento--column single-agendamento--column--2">
        <span className="single-agendamento--tratamento--title single-agendamento--title">
          {agendamento.tipo}
        </span>
        <span className="single-agendamento--tratamento--tratamento single-agendamento--text">
          {agendamento.tratamento}
        </span>
      </div>

      <div className="single-agendamento--medico single-agendamento--column single-agendamento--column--3">
        <span className="single-agendamento--medico--title single-agendamento--title">
          Médico
        </span>
        <span className="single-agendamento--medico--medico single-agendamento--text">
          {agendamento.medico.nome}
        </span>
      </div>
      <div className="single-agendamento--medico single-agendamento--column single-agendamento--column--3">
        <span className="single-agendamento--medico--title single-agendamento--title">
          Agendado por
        </span>
        <span className="single-agendamento--medico--medico single-agendamento--text">
          {agendamento.agendadoPor}
        </span>
      </div>

      {mostrarUnidade && (
        <div className="single-agendamento--medico single-agendamento--column single-agendamento--column--3">
          <span className="single-agendamento--medico--title single-agendamento--title">
            Onde
          </span>
          <span className="single-agendamento--medico--medico single-agendamento--text single-agendamento--unidade">
            {agendamento.estabelecimento.nome}
          </span>
        </div>
      )}

      {mostrarTodos && (
        <div className="single-agendamento--medico single-agendamento--column single-agendamento--column--4">
          <span
            className={`single-agendamento--medico--medico single-agendamento--text ${
              agendamento.atendido === true &&
              !agendamento.atendimentoNaoExecutado
                ? "single-agendamento--text__atendido"
                : agendamento.atendimentoNaoExecutado === true
                ? "single-agendamento--text__naoexecutado"
                : agendamento.faltou === true
                ? "single-agendamento--text__faltou"
                : ""
            }`}
          >
            {agendamento.atendido === true &&
            !agendamento.atendimentoNaoExecutado
              ? "Atendido"
              : agendamento.atendimentoNaoExecutado === true
              ? "Não Executado"
              : agendamento.faltou === true
              ? "Faltou"
              : ""}
          </span>
        </div>
      )}
    </div>
  );
}

export default SingleUpcomingAppointment;
